var map = {
	"./2.jpg": 3338,
	"./不锈钢盲文标牌.jpg": 9043,
	"./不锈钢盲文牌.jpg": 9808,
	"./地图.jpg": 6511,
	"./扶手标牌.jpg": 4182,
	"./摸读平面图.jpg": 7146,
	"./摸读平面图1.jpg": 9237,
	"./洗手间盲文牌.jpg": 967,
	"./盲文地图.jpg": 4413,
	"./盲文地图1.jpg": 6884,
	"./盲文牌-1.jpg": 7705,
	"./盲文牌.jpg": 6871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1271;